import React from "react";
import { Grid, TextField, Typography, Box, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Radio } from "@mui/material";

const STRUCTURE_OPTIONS = [
  "Individual",
  "Sole Trader",
  "Company",
  "Partnership",
  "Trust",
  "SMSF",
  "Other"
];

const PDF_TITLE_OPTIONS = [
  "Business Engagement",
  "Quotation"
];

const StepBusinessStructure = ({ data, onChange }) => {
  const handleChange = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>Document Title</Typography>
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12}>
          <FormControl fullWidth required>
            <InputLabel>Select PDF Title</InputLabel>
            <Select
              style={{minWidth:'320px'}}
              value={data.pdfTitle || ""}
              label="Select PDF Title"
              onChange={(e) => handleChange("pdfTitle", e.target.value)}
            >
              {PDF_TITLE_OPTIONS.map((opt) => (
                <MenuItem key={opt} value={opt}>{opt}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <Typography variant="h6" gutterBottom>Business Structure</Typography>
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12}>
          <FormControl fullWidth required disabled={!data.pdfTitle}>
            <InputLabel>Business Structure</InputLabel>
            <Select
              style={{minWidth:'320px'}}
              value={data.structure || ""}
              label="Business Structure"
              onChange={(e) => handleChange("structure", e.target.value)}
            >
              {STRUCTURE_OPTIONS.map((opt) => (
                <MenuItem key={opt} value={opt}>{opt}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {data.structure === "Other" && (
            <Grid item xs={12} md={6}>
                <TextField 
                    fullWidth
                    label="Specify Other Structure"
                    value={data.businessStructureOther || ""}
                    onChange={(e) => handleChange("businessStructureOther", e.target.value)}
                    required
                />
            </Grid>
        )}
      </Grid>
      <Typography variant="h6" gutterBottom>Closing Statement</Typography>
      <Grid item xs={12}>
          <FormControl>
              <Typography variant="subtitle2" gutterBottom>Add Closing Statement?</Typography>
              <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                    <FormControlLabel
                      control={
                          <Radio 
                              checked={data.hasClosingStatement === true || data.hasClosingStatement === 'true' || data.hasClosingStatement === 'yes'}
                              onChange={() => handleChange("hasClosingStatement", true)}
                          />
                      }
                      label="Yes"
                  />
                  <FormControlLabel
                      control={
                          <Radio 
                              checked={data.hasClosingStatement === false || data.hasClosingStatement === 'false' || data.hasClosingStatement === 'no' || data.hasClosingStatement === undefined}
                              onChange={() => handleChange("hasClosingStatement", false)}
                          />
                      }
                      label="No"
                  />
              </Box>
          </FormControl>
          
          {(data.hasClosingStatement === true || data.hasClosingStatement === 'true' || data.hasClosingStatement === 'yes') && (
              <TextField 
                  fullWidth
                  label="Closing Statement Message"
                  multiline
                  minRows={3}
                  value={data.closingStatementText || ""}
                  onChange={(e) => handleChange("closingStatementText", e.target.value)}
                  helperText="This message will appear at the bottom of the quotation PDF."
              />
          )}
      </Grid>
    </Box>
  );
};

export default StepBusinessStructure;
